import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './subscription.css';
import medic from '../../assets/images/Medic.png';
import { FaArrowDown, FaEdit } from "react-icons/fa";
import { motion } from 'framer-motion';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';

const Subscription = () => {
  const location = useLocation();
  const hospital_admin_id = location.state;

  const [subscriptions, setSubscriptions] = useState([]);
  const [features, setFeatures] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [durationValue, setDurationValue] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0); // Valeur initiale du total

  // Calcul du prix total
  const calculateTotalPrice = () => {
    // Calcul du total pour chaque feature
    const calculatedTotal = customFeatures.reduce((total, feature) => {
      const originalFeature = features.find(f => f._id === feature.featureId);
      // Utiliser (feature.quantity || 1) pour être cohérent avec l'affichage
      return total + ((feature.quantity || 1) * originalFeature.price);
    }, 0);
  
    // Multiplier par la durée après avoir calculé le total des features
    const finalTotal = (calculatedTotal * durationValue).toFixed(2);
    setTotalPrice(finalTotal);
  };


  const handleDurationChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;
    setDurationValue(newValue);
    // Recalculer le prix total après changement de durée
    calculateTotalPrice();
  };
  
  // Nouveaux états pour la personnalisation
  const [isCustomizing, setIsCustomizing] = useState(false);
  const [customFeatures, setCustomFeatures] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        setLoading(true);
        const { data } = await api.get('/api/subscriptions');
        setSubscriptions(data);
      } catch (err) {
        setError('Erreur lors de la récupération des abonnements.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const { data } = await api.get('/api/getallfeatures');
        setFeatures(data);
        const Editable = data.filter(item => item.isEditable === true);
        
        // Initialiser les features personnalisables
        setCustomFeatures(Editable.map(feature => ({
          featureId: feature._id,
          name: feature.name,
          quantity: 1
        })));
      } catch (err) {
        setError('Erreur lors de la récupération des fonctionnalités.');
        console.error(err);
      }
    };

    fetchFeatures();
  }, []);

  useEffect(() => {
    calculateTotalPrice();
  }, [customFeatures, durationValue]); // Recalculer quand les features ou la durée changent
  

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const handleChoose = async (subscription) => {
    try {
      // Envoi des données à la route POST
      const hospitalSpecIdGet = await getHospitalsByAdmin(hospital_admin_id);  // Attendez la réponse avant d'envoyer
      await api.post('/api/selectplan', { subscription_id: subscription._id, hospitalSpecId: hospitalSpecIdGet });

      // Redirection après succès
      navigate(`/plan/${subscription._id}`);
    } catch (err) {
      console.error('Erreur lors de la soumission du plan :', err);
      setError('Une erreur est survenue lors de la sélection du plan.');
    }
  };

  const handleCustomFeatureChange = (featureId, quantity) => {
    setCustomFeatures(prev => 
      prev.map(f => 
        f.featureId === featureId 
          ? { ...f, quantity: Math.max(1, quantity) } // Minimum 1 au lieu de 0
          : f
      )
    );
  };

  const handleCreateCustomPlan = async () => {
    try {
      // Filtrer les features avec une quantité > 0
      const selectedFeatures = customFeatures
        .filter(f => f.quantity > 0)
        .map(f => ({
          featureId: f.featureId,
          quantity: f.quantity
        }));

      const hospitalSpecIdGet = await getHospitalsByAdmin(hospital_admin_id);
      
      const dataToSend = {
          hospitalSpecId: hospitalSpecIdGet,
          features: selectedFeatures,
          planDuration: durationValue,
          planPrice: totalPrice,
          planEndDate: ''
        }
      const response= await api.post('/api/customize-subscription', dataToSend);

      // console.log(response?.data?.plan);
      // console.log(dataToSend);
      

      // Naviguer vers la page de détail du plan personnalisé
      if (response.status === 200 || response.status === 201) {
        navigate(`/planPersonalized/${response?.data?.plan?._id}`);        
      } else {
        alert(''); 
      }
    } catch (err) {
      // console.error('Erreur lors de la création du plan personnalisé:', err?.response?.data?.message);
      toast.error(err?.response?.data?.message);
      setError('Une erreur est survenue lors de la création du plan.');
    }
  };

  const getHospitalsByAdmin = async (hospitalAdminId) => {
    try {
      const responseHospital = await api.get(`/api/hospitals/admin/${hospitalAdminId}`);
      
      if (responseHospital.data && responseHospital.data.length > 0) {
        const hospital = responseHospital.data[0];
        return hospital.hospital_spec_id;
      } else {
        toast.error("Aucun hôpital trouvé");
        return null;
      }
    } catch (error) {
      // console.error('Error fetching hospital:', error?.response?.data?.message);
      toast.error(error?.response?.data?.message);
      return null;
    }
  };

  const toggleCustomization = () => {
    setIsCustomizing(!isCustomizing);
  };

  // Reste du code du composant précédent...

  return (
    <div className="subscription-container">
      <ToastContainer />
      <motion.div
        initial={{ x: '-100vw' }}
        animate={{ x: 0 }}
        exit={{ x: '100vw' }}
        transition={{ duration: 0.5 }}
      >
        {/* Contenu précédent... */}
        <div className="microbe">
          <div className="couleur">
            <img src={medic} alt="Medic" className="medic mb-3 mt-2" />
            <div className="container one">
              <div className="row">
                <div className="col-lg-3">
                  <h1 className="prune">
                    <span className="fous1">Med</span>
                    <span className="fous2">Tinz</span>
                  </h1>
                </div>
                <div className="col-lg-6">
                  <div className="cana">
                    <h2 className="claude text-center mt-2">
                      Choose the right medical subscription for you
                    </h2>
                    <p className="rich">
                      Choose the plan that’s right for your business. Whether you’re just getting started with email marketing or well down the path to personalization, we’ve got you covered.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          {/* Bouton de personnalisation */}
          <div className="text-center my-3">
            <button 
              className="btn btn-primary" 
              onClick={toggleCustomization}
            >
              <FaEdit /> {isCustomizing ? 'Back to plans' : 'Customize a plan'}
            </button>
          </div>

          {/* Vue de personnalisation */}
          {isCustomizing && (
            <div className="container two mb-4 pb-4">
              <h3>Customize your plan</h3>
              
              <tr key={'duration'} className='m-4 p-2'>
                <td>Duration</td>
                <td>Daily</td>
                <td>
                  <input 
                    type="number" 
                    name="duration" 
                    id="duration" 
                    min="1" 
                    value={durationValue}
                    onChange={handleDurationChange}
                    className="form-control"
                  />
                </td>
                <td>
                  {/* {durationValue}  */}
                  Days
                </td>
              </tr>

              <table className="table">
                <thead>
                  <tr>
                    <th>Features</th>
                    <th>Unit price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {customFeatures.map(feature => {
                    const originalFeature = features.find(f => f._id === feature.featureId);
                    return (
                      <tr key={feature.featureId}>
                        <td>{feature.name}</td>
                        <td>{originalFeature.price} cfa </td>
                        <td>
                          <input 
                            type="number" 
                            min="1" 
                            value={feature.quantity || 1}
                            onChange={(e) => handleCustomFeatureChange(
                              feature.featureId, 
                              parseInt(e.target.value) || 0
                            )}
                            className="form-control"
                          />
                        </td>
                        <td>
                         {((feature.quantity || 1) * originalFeature.price).toFixed(2)} cfa 
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="3">Total price</td>
                    <td>
                    {totalPrice} cfa 
                    </td>
                  </tr>
                </tfoot>
              </table>
              <button 
                className="btn btn-success" 
                onClick={handleCreateCustomPlan}
              >
                Create my personalized plan
              </button>
            </div>
          )}

          {/* Reste du tableau des abonnements... */}
          {!isCustomizing && (
          <div className="container two">
            <div className="row">
              <div className="col-lg-12 mt-4 mb-5">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="hidden-th">Features</th>
                      {subscriptions.map((subscription, index) => (
                        <th key={index}>
                          <p onClick={() => setSelectedPlan(subscription.name)}>
                            {subscription.type}
                            <br />
                            <span className="trip">${subscription.price}</span> 
                            <span className="solo">/ {subscription.duration} month</span>
                          </p>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {features.map((feature, index) => (
                      <tr key={index}>
                        <td className="reve">{feature.name}</td>
                        {subscriptions.map((subscription) => {
                          const featureValue = subscription.features[index];
                          const valueToDisplay = featureValue && typeof featureValue === 'object' ? JSON.stringify(featureValue) : featureValue;

                          return (
                            <td
                              key={subscription._id}
                              className={`rive ${selectedPlan === subscription.name ? 'selected' : ''}`}
                            >
                              {valueToDisplay === "true" ? '✔' : (valueToDisplay === "false" || !valueToDisplay) ? '−' : valueToDisplay}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <button
                          className="btn btn-link more-info-btn"
                          onClick={toggleShowAll}
                        >
                          {/* <FaArrowDown /> {showAll ? ' CLICK TO VIEW MORE FEATURES' : ' CLICK TO VIEW MORE FEATURES'} */}
                        </button>
                      </td>
                      {subscriptions.map((subscription, index) => (
                        <td key={index}>
                          <button
                            className="choose-btn"
                            onClick={() => handleChoose(subscription)}
                          >
                            Choose
                          </button>
                        </td>
                      ))}
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default Subscription;